import React from "react";
import { Filter } from "react-admin";
import InstructionLanguagesInput from "server/components/Fields/InstructionLanguagesInput";
import StructuralUnitsInput from "server/components/Fields/StructuralUnitsInput";

const AcademicSessionsListFilters = ({ ...props }) => {
  return (
    <Filter {...props}>
      <StructuralUnitsInput
        source="structuralUnitId"
        filterByUser={true}
        alwaysOn
        fullWidth
      />
      <InstructionLanguagesInput
        source="instructionLanguageId"
        alwaysOn={false}
      />
    </Filter>
  );
};

export default AcademicSessionsListFilters;
